import publicApiClient from '../publicApiClient';

/**
 * Service for order session token validation
 */
export const orderSessionService = {
    /**
     * Validate an order session token
     * @param {string} token - JWT token from URL
     * @returns {Promise<{valid: boolean, customerId: string, supplierPublicId: string, tokenType: string, expiresAt: string, errorMessage: string}>}
     */
    async validateOrderToken(token) {
        try {
            const response = await publicApiClient.post('/public/order-session/validate', {
                token
            });
            return response.data;
        } catch (error) {
            // If 401, the token is invalid but we still get the response
            if (error.response?.status === 401) {
                return error.response.data;
            }
            throw error;
        }
    },
    /**
     * Get order session context (token validation + customer + supplier details)
     * @param {string} token - JWT token from URL
     * @returns {Promise<{valid: boolean, customer: Object, tenant: Object, errorMessage: string}>}
     */
    async getSessionContext(token) {
        try {
            console.log('[OrderSessionService] Fetching session context for token:', token);
            const response = await publicApiClient.post('/public/order-session/context', {
                token
            });
            return response.data;
        } catch (error) {
            console.error('[OrderSessionService] Context fetch failed:', error);
            if (error.response?.status === 401 || error.response?.status === 500) {
                return error.response.data;
            }
            throw error;
        }
    }
};
